module.exports = __webpack_public_path__ + "media/images/maquinas-de-cafe-41e31a9c5f4706460b1c3eb061dcab3c.jpg";